<template>
  <div>

    <!-- <div class="container-fluid">
    <v-row>
    <v-col cols="12" sm="12" md="12"> -->

    <div class="container-fluid title-page">
      <v-row>
        <v-col cols="12" sm="12">
          <h2>{{ title }}</h2>
        </v-col>
      </v-row>
    </div>

    <div class="container-fluid">
      <div class="destaque-busca destaque-busca-register">
        <v-row>
          <v-col cols="12" sm="12" md="4" lg="2" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
                 data-wow-offset="40">
            <img src="@/assets/home-img-2.png" alt="" class="img-fluid"/>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="10" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
                 data-wow-offset="40">
            <v-col cols="12" sm="12" md="12">
              <h5>Vamos lá!</h5>
              <p>Em poucos instantes você poderá disponibilizar conhecimento e<br/> aprendizagem para a sua equipe e
                seus clientes.</p>
              <!-- <v-btn dark href="/courses">Ver todos os cursos</v-btn> -->
            </v-col>
          </v-col>
        </v-row>
      </div>
    </div>

    <div class="container-fluid mt-10">
      <v-stepper class="stepper-custom" v-model="tabActive" @change="changeStep">
        <v-stepper-header>
          <template v-for="(item, $index) in menuItems">
            <v-stepper-step edit-icon="check" :editable="item.editable" :complete="tabActive > item.step"
                            :step="item.step" :key="`menu${$index}`">
              {{ item.title }}
            </v-stepper-step>
            <v-divider v-if="$index < menuItems.length - 1" :key="$index"></v-divider>
          </template>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <slot name="step1"></slot>
          </v-stepper-content>
          <v-stepper-content step="2">
            <slot name="step2"></slot>
          </v-stepper-content>
          <v-stepper-content step="3">
            <slot name="step3"></slot>
          </v-stepper-content>
          <v-stepper-content step="4">
            <slot name="step4"></slot>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserCourseRegister',
  data: () => ({
    menuItems: [
      { step: 1, title: 'Curso', editable: false },
      { step: 2, title: 'Módulos', editable: false },
      { step: 3, title: 'Conteúdo', editable: false },
      { step: 4, title: 'Quiz', editable: false },
    ],
    tabActive: 1,
  }),
  computed: {
    title () {
      return this.$route.meta.title
    }
  },
  created () {
    if (this.$route.name === 'course-create-step2') {
      this.tabActive = 2
    }
    if (this.$route.name === 'course-create-step3') {
      this.tabActive = 3
    }
    if (this.$route.name === 'course-create-step4') {
      this.tabActive = 4
    }

    this.enableTabs(this.tabActive)
  },
  methods: {
    changeStep (step) {
      this.enableTabs(step)

      const route = {
        name: `course-create-step${step}`
      }

      if (this.$route.params.courseId) {
        route.params = {
          courseId: this.$route.params.courseId
        }
      }

      this.$router.push(route)
    },
    enableTabs (tabActive) {
      for (let i = 0; i < this.menuItems.length; i++) {
        if (this.$route.params.courseId) {
          this.menuItems[i].editable = true
        }

        if (tabActive >= this.menuItems[i].step) {
          this.menuItems[i].editable = true
        }
      }
    }
    // next () {
    //   const active = parseInt(this.tabActive)
    //
    //   this.tabActive = (active < 4 ? active + 1 : 0)
    // },
    // nextToModules (course) {
    //   const active = parseInt(this.tabActive)
    //
    //   this.course = course
    //
    //   this.tabActive = (active < 4 ? active + 1 : 0)
    // },
    // nextToContents (course) {
    //   const active = parseInt(this.tabActive)
    //
    //   if (course) {
    //     this.course = course
    //   }
    //
    //   this.tabActive = (active < 4 ? active + 1 : 0)
    // },
    // nextToQuiz (course) {
    //   const active = parseInt(this.tabActive)
    //
    //   if (course) {
    //     this.course = course
    //   }
    //
    //   this.tabActive = (active < 4 ? active + 1 : 0)
    // },
    // back () {
    //   const active = parseInt(this.tabActive)
    //   this.tabActive = (active > 1 ? active - 1 : 0)
    // },
    //
    // finish () {
    //   this.axios.put('/course/active', {
    //     _id: this.course._id,
    //     active: true
    //   }).then(({ data }) => {
    //     if (data.success) {
    //       this.$swal('Sucesso', 'Curso salvo e ativado!', 'success').then(() => {
    //         this.$router.push({ name: 'course-my' })
    //       })
    //     }
    //   })
    //
    // },
  }
}
</script>

<style lang="scss" scoped>
.upload-btn label {
  margin: 0 !important;
}

#labeluploadFile {
  margin: 0 !important;
}

.progress {
  .text-xs-center {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: -10px !important;
  }

  .v-progress-linear {
    margin-bottom: 50px;
  }
}
</style>
